import styled from "styled-components";

export const StyledOptionGroup = styled.div`
  display: flex;
  gap: 16px;
  margin: 16px 0;
`;
